export default "__VITE_ASSET__FismPirY__"